#import "./TrainingCourseAdminFields.graphql"

mutation ArchiveTrainingCourse($courseId: ID!) {
  archiveTrainingCourse(input: { courseId: $courseId }) {
    trainingCourse {
      ...TrainingCourseAdminFields
    }
  }
}
